import React, { useState } from "react";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CartDrawer from "./CartDrawer";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { useToast } from "../hooks/use-toast";
import { Sparkles, Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const HR_EMAIL = "hello@beblushify.com";

const BecomeBeautician = () => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", phone: "", email: "", city: "", experience: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) { toast({ title: "Please enter name & phone" }); return; }
    setSending(true);
    try {
      const res = await axios.post(`${API}/beautician-apply`, form);
      toast({ title: "Application received!", description: res.data.message });
      // also open email draft to HR so it reaches their inbox
      const subject = encodeURIComponent(`Beautician Application - ${form.name}`);
      const body = encodeURIComponent(`Name: ${form.name}\nPhone: ${form.phone}\nEmail: ${form.email}\nCity: ${form.city}\nExperience: ${form.experience}\n\nMessage:\n${form.message}`);
      window.location.href = `mailto:${HR_EMAIL}?subject=${subject}&body=${body}`;
      setForm({ name: "", phone: "", email: "", city: "", experience: "", message: "" });
    } catch { toast({ title: "Failed to submit", description: "Please try again." }); } finally { setSending(false); }
  };

  return (
    <>
      <Navbar />
      <main className="min-h-[60vh] max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <span className="inline-flex items-center gap-2 bg-secondary text-primary px-4 py-1.5 rounded-full text-sm font-medium"><Sparkles className="w-4 h-4 text-accent" /> Join Our Team</span>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mt-4">Become a Beautician</h1>
        <p className="text-gray-600 mt-3">Are you a skilled beautician? Join BeBlushify and earn on your own schedule. Fill the form below and our team will reach out. Your application is also emailed to <b>{HR_EMAIL}</b>.</p>

        <form onSubmit={submit} className="mt-8 bg-white rounded-2xl ring-1 ring-black/5 shadow-sm p-6 space-y-4">
          <div className="grid sm:grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label>Full Name *</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
            <div className="space-y-1.5"><Label>Phone *</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
          </div>
          <div className="grid sm:grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label>Email</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
            <div className="space-y-1.5"><Label>City / Area</Label><Input value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} /></div>
          </div>
          <div className="space-y-1.5"><Label>Experience (e.g. 3 years, services you offer)</Label><Input value={form.experience} onChange={(e) => setForm({ ...form, experience: e.target.value })} /></div>
          <div className="space-y-1.5"><Label>About You</Label><Textarea rows={4} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Tell us about your skills & availability" /></div>
          <Button type="submit" disabled={sending} className="w-full bg-primary hover:bg-primary/90 h-11"><Send className="w-4 h-4 mr-1.5" /> {sending ? "Submitting..." : "Submit Application"}</Button>
        </form>
      </main>
      <Footer />
      <CartDrawer />
    </>
  );
};

export default BecomeBeautician;
